//EMP ======================================
//const dataArray = [
//   {
      // oldKey:"id",
      // newKey:"code"
//   },
//   {...},
// ] =======================================
export const arrayObject = (dataArray,setKeyObj) => {
  var newArrayObject = []

  dataArray.forEach(data => {
    var newData = {}
    setKeyObj.forEach(dataKey => {
      const oldData = data[dataKey.oldKey]
      if(oldData || oldData === 0){
        newData[dataKey.newKey] = oldData
      }
    })
    newArrayObject.push(newData)
  })
  return newArrayObject
} 
export const arrayTypeKeyObject = (dataArray,keyName) => {
  var newObject = {}

  dataArray.forEach(data => {
    newObject[data[keyName]] = data 
  })
  return newObject
}
